export default __webpack_public_path__ + "static/media/spotterful-workplace-logo.fd7537d9.svg";